import Image from 'components/image/image'
import Link from 'next/link'
import Heading from 'components/heading/heading'
import Panel from 'components/panel/panel'
import styles from './articles.module.scss'
import { cn, getRoute } from 'utils/helpers'

export default function Articles({ articles }) {
    return (
        <div className={cn(styles.list, 'mb72')}>
            {articles.map(item => {
                const url = getRoute('blog-article', item)
                const categoryUrl = getRoute('blog-category', { slug: item.category_slug, buyers: item.buyers })

                return (
                    <Panel key={item.slug} tag="article" className={cn(styles.panel, 'mb48')}>
                        <div className={styles.image}>
                            <Image
                                src={item.image}
                                alt={item.name}
                                layout="responsive"
                                objectFit="cover"
                                width={180}
                                height={180}
                            />
                            <Link href={url}>
                                <a aria-label={item.name}></a>
                            </Link>
                        </div>
                        <div className={styles.text}>
                            <div className={styles.inline}>
                                <Heading tag="h2" size="24">
                                    <Link href={url}>
                                        <a>{item.name}</a>
                                    </Link>
                                </Heading>
                            </div>
                            <div className={styles.description}>
                                <p className={styles.excerpt}>{item.excerpt}</p>
                                <p>
                                    {item.date},{' '}
                                    <Link href={categoryUrl}>
                                        <a>{item.category_name}</a>
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </Panel>
                )
            })}
        </div>
    )
}
